import React from "react"
import KEYBlue from "../common/keylist-blue"
type Props = {
  title: string
}

const EnterpriseSoftwareDevelopment: React.FC<Props> = ({ title }) => {
  return (
    <section className="Development-Services section-py">
      <div className="container lg:container mx-auto">
        <div className="row grid lg:grid-cols-12  justify-start items-center">
          <div className="lg:col-span-8">
            <div className="Development-Services-head text-start mb-5">
              <h2 className="fw-700 fs-xl">{title}</h2>
            </div>
          </div>
        </div>
        <div className="row grid lg:grid-cols-12 xl:grid-cols-12 md:grid-cols-12 gy-10">
          <div className="xl:col-span-6 lg:col-span-12 md:col-span-12">
            <div className="dev-service-inner">
              <p className="fs-md text-secondary fw-400">
              In todays digital world, businesses of all sizes need enterprise software to streamline operations, boost productivity, and improve customer engagement. But with so many different options available, how do you choose the right enterprise software development company for your needs?
              </p>
              <p className="fs-md text-secondary fw-400">
              Moweb is a leading enterprise software development company driven to deliver exceptional digital experiences, products, and platforms that fuel your business growth. We understand that every business is unique, so we tailor our software solutions to meet your specific needs. Our team of expert developers, engineers, and programmers is well-versed in a wide range of cutting-edge technologies and tools, including:
              </p>
              <p className="fs-md text-secondary mb-0 fw-400">
              We help you plan for the future and stay ahead of the competition with our full-range of enterprise software development services. Whether transforming legacy systems or innovating with fresh ideas, our DevOps-fueled services ensure agile workflows and project success.
              </p>
            </div>
          </div>
          <div className="xl:col-span-6 lg:col-span-12 md:col-span-12">
            <div className="row grid md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1">
              <div>
                <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                  <KEYBlue text="Custom CRM, CMS, ECM, ERP, HRM, third-party, and IoT integration" />
                  <KEYBlue text="Odoo, Salesforce, HubSpot, ActiveCampaign, Monday, Keap, ServiceNow, etc implementation" />
                  <KEYBlue text="Back-end languages like Ruby on Rails and PHP" />
                  <KEYBlue text="Front-end frameworks such as Angular and React" />
                  <KEYBlue text="Mobile app development (iOS, Android)" />
                  <KEYBlue text="Next-gen technologies like AI, IoT, and Blockchain" />
                  <KEYBlue text="Various databases (MongoDB, PostgreSQL, MySQL)" />
                  <KEYBlue text="Version control systems like GitHub" />
                  <KEYBlue text="Communication tools like Slack" />
                  <KEYBlue text="Project management tools including Jira" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default EnterpriseSoftwareDevelopment
